module.exports = __webpack_public_path__ + "assets/word_cloud_visit.06589afc.svg";